import React from 'react'
import PropTypes from 'prop-types'
import withLayout from '../../../layout/withLayout'
import ContentBox from '../../../layout/component/ContentBox'
import { lifecycle } from 'recompose'
import { renderProcessName, renderTaskName } from '../../util/names'
import Select from '../../../form/component/Select'
import { EXTERNAL_VALUE_LIST, PRIORITY_VALUE_LIST, SLA_VALUE_LIST } from '../../state/task-definition/const'
import { default as MultiSelect } from 'react-select'
import { ROLE_LIST_EMPLOYEE, ROLE_LIST_PARTNER } from '../../../security/state/auth/const'

const formatMultiSelect = (itemList) => {
    return itemList.map(item => ({
        value: item,
        label: item,
    }))
}

const ROLE_LIST_INTERNAL_SELECT = formatMultiSelect(ROLE_LIST_EMPLOYEE)

const ROLE_LIST_PARTNER_SELECT = formatMultiSelect(ROLE_LIST_PARTNER)


const TaskDefinition = ({ taskDefinition, changeTaskDefinition, saveTaskDefinition }) => {
    return (
        <tr>
            <td>{renderProcessName(taskDefinition.processName)}</td>
            <td>{renderTaskName(taskDefinition.taskName)}</td>
            <td>
                <Select
                    object={taskDefinition}
                    name="external"
                    addEmpty={true}
                    valueList={EXTERNAL_VALUE_LIST}
                    onChange={(name, value) => {
                        changeTaskDefinition(taskDefinition.id, name, value)
                        saveTaskDefinition(taskDefinition.id)
                    }}
                />
            </td>
            <td>
                <Select
                    object={taskDefinition}
                    name="sla"
                    valueList={SLA_VALUE_LIST}
                    type="int"
                    onChange={(name, value) => {
                        changeTaskDefinition(taskDefinition.id, name, value)
                        saveTaskDefinition(taskDefinition.id)
                    }}
                />
            </td>
            <td>
                <Select
                    object={taskDefinition}
                    name="priority"
                    valueList={PRIORITY_VALUE_LIST}
                    type="int"
                    onChange={(name, value) => {
                        changeTaskDefinition(taskDefinition.id, name, value)
                        saveTaskDefinition(taskDefinition.id)
                    }}
                />
            </td>
            <td width="400">
                <MultiSelect
                    isMulti
                    defaultValue={formatMultiSelect(taskDefinition.roleList)}
                    onChange={(data) => {
                        const roleList = data.map(item => {
                            return item.value
                        })
                        changeTaskDefinition(taskDefinition.id, 'roleList', roleList)
                        saveTaskDefinition(taskDefinition.id)
                    }}
                    options={taskDefinition.external ? ROLE_LIST_PARTNER_SELECT : ROLE_LIST_INTERNAL_SELECT}
                    classNamePrefix="sunshine-multi-select"
                />
            </td>
        </tr>
    )
}


const TaskDefinitionList = ({ taskDefinitionList, changeTaskDefinition, saveTaskDefinition }) => {
    if (taskDefinitionList.length === 0) {
        return null
    }
    return (
        <ContentBox title="Task Definition">
            <table className="default-table-no-overflow">
                <thead>
                    <tr>
                        <th>Process name</th>
                        <th>Task name</th>
                        <th>External</th>
                        <th>SLA</th>
                        <th>Priority</th>
                        <th>RoleList</th>
                    </tr>
                </thead>
                <tbody>

                    {
                        taskDefinitionList.map(taskDefinition => {
                            return (<TaskDefinition
                                key={taskDefinition.id}
                                taskDefinition={taskDefinition}
                                changeTaskDefinition={changeTaskDefinition}
                                saveTaskDefinition={saveTaskDefinition}
                            />

                            )
                        })
                    }
                </tbody>
            </table>
        </ContentBox>
    )
}


TaskDefinitionList.propTypes = {
    taskDefinitionList: PropTypes.array.isRequired,

    findTaskDefinitionList: PropTypes.func.isRequired,
    changeTaskDefinition: PropTypes.func.isRequired,
    saveTaskDefinition: PropTypes.func.isRequired,
}

export default lifecycle({
    componentDidMount () {
        this.props.findTaskDefinitionList()
    },
})(withLayout(TaskDefinitionList))





// WEBPACK FOOTER //
// ./src/modules/process/component/task-definition/TaskDefinition.js